// src\themes\lino\elements\Product\CategoryNav.tsx
"use client";

import React from "react";
import Link from "next/link";
import { loadThemeComponent } from "@/core/config/theme-component-loader";
import { useDictionary } from "@/core/hooks/use-dictionary";
const CustomButton = loadThemeComponent("CustomButton")

interface Category {
  label: string;
  value: string;
}

interface CategoryNavProps {
  categories: Category[];
  activeSlug: string;
}

function CategoryNavComponent({ categories, activeSlug }: CategoryNavProps) {
  const { dictionary } = useDictionary()
  const allCategories = React.useMemo(
    () => [{ label: dictionary.ui.profile.all, value: "all" }, ...categories],
    [categories]
  );

  return (
    <nav className="flex gap-3 overflow-x-auto py-7 border-b border-primary-900 mb-10 no-scrollbar">
      {allCategories.map(({ label, value }) => {
        const isActive = activeSlug === value;

        return (
          <CustomButton
            asChild
            key={value}
            size="sm"
            variant={isActive ? "default" : "outline"}
          >
            <Link href={`/shop/category/products/${value}`}>{label}</Link>
          </CustomButton>
        );
      })}
    </nav>
  );
}

export const CategoryNav = React.memo(CategoryNavComponent);